import React from 'react';
import { Row, Col, Input, message, Button, TagType, Typography, Collapse } from 'antd';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import { nl2br } from '../../../utils/utils';

const { Search } = Input;
const { Panel } = Collapse;
const { Title } = Typography;

function SingleSignatureRemediationSteps(props) {
  let { remediationSteps } = props;
  remediationSteps = remediationSteps.replace(/['"]+/g, '');

  return (
    <Collapse accordion>
      <Panel
        header={
          <Title level={5} className="mb-0">
            Manual Remediation
          </Title>
        }
        key="1"
      >
        <p
          style={{ fontSize: 14, lineHeight: '20px' }}
          dangerouslySetInnerHTML={{
            __html: nl2br(remediationSteps && remediationSteps),
          }}
        />
      </Panel>
    </Collapse>
  );
}

export default SingleSignatureRemediationSteps;
